// Seniority options from Audience API
export const seniorityOptions = [
  { value: "cxo", label: "CXO" },
  { value: "vp", label: "VP" },
  { value: "director", label: "Director" },
  { value: "manager", label: "Manager" },
  { value: "staff", label: "Staff" },
];

// Department options from Audience API
export const departmentOptions = [
  { value: "administrative", label: "Administrative" },
  {
    value: "community and social services",
    label: "Community and Social Services",
  },
  { value: "education", label: "Education" },
  { value: "engineering", label: "Engineering" },
  { value: "executive", label: "Executive" },
  { value: "finance", label: "Finance" },
  { value: "government", label: "Government" },
  { value: "health services", label: "Health Services" },
  { value: "human resources", label: "Human Resources" },
  { value: "information technology", label: "Information Technology" },
  { value: "legal", label: "Legal" },
  { value: "media and communications", label: "Media and Communications" },
  {
    value: "military and protective services",
    label: "Military and Protective Services",
  },
  { value: "marketing", label: "Marketing" },
  { value: "operations", label: "Operations" },
  { value: "product management", label: "Product Management" },
  { value: "real estate", label: "Real Estate" },
  { value: "sales", label: "Sales" },
];

// Gender options
export const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

// Common US cities
export const commonCities = [
  "New York",
  "Los Angeles",
  "Chicago",
  "Houston",
  "Phoenix",
  "Philadelphia",
  "San Antonio",
  "San Diego",
  "Dallas",
  "San Jose",
  "Austin",
  "Jacksonville",
  "Fort Worth",
  "Columbus",
  "San Francisco",
  "Charlotte",
  "Indianapolis",
  "Seattle",
  "Denver",
  "Boston",
  "Miami",
  "Atlanta",
  "Portland",
  "Las Vegas",
  "Minneapolis",
];

// Common industries from Audience API
export const commonIndustries = [
  "Accounting",
  "Administration Of Justice",
  "Advertising Services",
  "Airlines And Aviation",
  "Alternative Dispute Resolution",
  "Alternative Medicine",
  "Animation And Post-Production",
  "Appliances, Electrical, And Electronics Manufacturing",
  "Architecture And Planning",
  "Armed Forces",
  "Artists And Writers",
  "Automation Machinery Manufacturing",
  "Automotive",
  "Aviation And Aerospace Component Manufacturing",
  "Banking",
  "Beverage Manufacturing",
  "Biotechnology Research",
  "Book And Periodical Publishing",
  "Broadcast Media Production And Distribution",
  "Building Construction",
  "Business Consulting And Services",
  "Business Skills Training",
  "Capital Markets",
  "Chemical Manufacturing",
  "Civic And Social Organizations",
  "Civil Engineering",
  "Commercial Real Estate",
  "Computer And Network Security",
  "Computer Games",
  "Computer Hardware Manufacturing",
  "Computer Networking",
  "Computers And Electronics Manufacturing",
  "Consumer Electronics",
  "Consumer Goods",
  "Consumer Services",
  "Cosmetics",
  "Dairy Product Manufacturing",
  "Defense And Space Manufacturing",
  "Design Services",
  "E-Learning Providers",
  "Education Administration Programs",
  "Entertainment Providers",
  "Environmental Services",
  "Events Services",
  "Executive Offices",
  "Facilities Services",
  "Farming",
  "Financial Services",
  "Fine Art",
  "Fisheries",
  "Food And Beverage Services",
  "Freight And Package Transportation",
  "Fundraising",
  "Furniture And Home Furnishings Manufacturing",
  "Gambling Facilities And Casinos",
  "Glass, Ceramics And Concrete Manufacturing",
  "Government Administration",
  "Government Relations Services",
  "Health, Wellness And Fitness",
  "Higher Education",
  "Hospitality",
  "Hospitals And Health Care",
  "Human Resources Services",
  "Individual And Family Services",
  "Industrial Machinery Manufacturing",
  "Insurance",
  "International Affairs",
  "International Trade And Development",
  "Internet",
  "Internet Publishing",
  "Investment Banking",
  "Investment Management",
  "It Services And It Consulting",
  "Judiciary",
  "Law Enforcement",
  "Law Practice",
  "Leasing Real Estate",
  "Legal Services",
  "Legislative Offices",
  "Leisure, Travel & Tourism",
  "Libraries",
  "Logistics And Supply Chain",
  "Machinery Manufacturing",
  "Manufacturing",
  "Maritime Transportation",
  "Market Research",
  "Marketing Services",
  "Mechanical Or Industrial Engineering",
  "Medical Equipment Manufacturing",
  "Medical Practices",
  "Mental Health Care",
  "Military",
  "Mining",
  "Mobile Gaming Apps",
  "Motion Pictures And Film",
  "Motor Vehicle Manufacturing",
  "Movies, Videos, And Sound",
  "Museums, Historical Sites, And Zoos",
  "Musicians",
  "Nanotechnology Research",
  "Newspaper Publishing",
  "Newspapers",
  "Non-Profit Organizations",
  "Oil And Gas",
  "Online Audio And Video Media",
  "Outsourcing And Offshoring Consulting",
  "Packaging And Containers Manufacturing",
  "Paper And Forest Product Manufacturing",
  "Personal Care Product Manufacturing",
  "Pharmaceutical Manufacturing",
  "Philanthropic Fundraising Services",
  "Photography",
  "Plastics Manufacturing",
  "Political Organizations",
  "Primary And Secondary Education",
  "Printing Services",
  "Professional Training And Coaching",
  "Program Development",
  "Public Policy Offices",
  "Public Relations And Communications Services",
  "Public Safety",
  "Railroad Equipment Manufacturing",
  "Ranching",
  "Recreational Facilities",
  "Religious Institutions",
  "Renewable Energy Semiconductor Manufacturing",
  "Renewables & Environment",
  "Research",
  "Research Services",
  "Restaurants",
  "Retail",
  "Retail Apparel And Fashion",
  "Retail Art Supplies",
  "Retail Groceries",
  "Retail Luxury Goods And Jewelry",
  "Retail Office Equipment",
  "Security And Investigations",
  "Semiconductor Manufacturing",
  "Shipbuilding",
  "Software Development",
  "Spectator Sports",
  "Sporting Goods Manufacturing",
  "Sports",
  "Strategic Management Services",
  "Supermarkets",
  "Technology, Information And Internet",
  "Telecommunications",
  "Textile Manufacturing",
  "Think Tanks",
  "Tobacco Manufacturing",
  "Translation And Localization",
  "Transportation, Logistics, Supply Chain And Storage",
  "Travel Arrangements",
  "Truck Transportation",
  "Utilities",
  "Venture Capital And Private Equity Principals",
  "Veterinary Services",
  "Warehousing And Storage",
  "Wellness And Fitness Services",
  "Wholesale",
  "Wholesale Building Materials",
  "Wholesale Import And Export",
  "Wine And Spirits",
  "Wireless Services",
  "Writing And Editing",
];

// US States - Using 2-letter abbreviations for AudienceLab API compatibility
export const usStates = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

// Employee count ranges
export const employeeCountOptions = [
  { value: "1 to 10", label: "1 to 10" },
  { value: "11 to 25", label: "11 to 25" },
  { value: "26 to 50", label: "26 to 50" },
  { value: "51 to 100", label: "51 to 100" },
  { value: "101 to 250", label: "101 to 250" },
  { value: "251 to 500", label: "251 to 500" },
  { value: "501 to 1000", label: "501 to 1,000" },
  { value: "1001 to 5000", label: "1,001 to 5,000" },
  { value: "5001 to 10000", label: "5,001 to 10,000" },
  { value: "10000+", label: "10,000+" },
];

// Company revenue ranges
export const companyRevenueOptions = [
  { value: "Under 1 Million", label: "Under $1 Million" },
  { value: "1 Million to 5 Million", label: "$1M to $5M" },
  { value: "5 Million to 10 Million", label: "$5M to $10M" },
  { value: "10 Million to 25 Million", label: "$10M to $25M" },
  { value: "25 Million to 50 Million", label: "$25M to $50M" },
  { value: "50 Million to 100 Million", label: "$50M to $100M" },
  { value: "100 Million to 250 Million", label: "$100M to $250M" },
  { value: "250 Million to 500 Million", label: "$250M to $500M" },
  { value: "500 Million to 1 Billion", label: "$500M to $1B" },
  { value: "1 Billion and Over", label: "$1 Billion+" },
];

// Income range options (from Audience API)
export const incomeRangeOptions = [
  { value: "less than $20,000", label: "Less than $20,000" },
  { value: "$20,000 to $44,999", label: "$20,000 to $44,999" },
  { value: "$45,000 to $59,999", label: "$45,000 to $59,999" },
  { value: "$60,000 to $74,999", label: "$60,000 to $74,999" },
  { value: "$75,000 to $99,999", label: "$75,000 to $99,999" },
  { value: "$100,000 to $149,999", label: "$100,000 to $149,999" },
  { value: "$150,000 to $199,999", label: "$150,000 to $199,999" },
  { value: "$200,000 to $249,999", label: "$200,000 to $249,999" },
  { value: "$250,000+", label: "$250,000+" },
];

// Net worth options (from Audience API)
export const netWorthOptions = [
  { value: "-$20,000 to -$2,500", label: "-$20,000 to -$2,500" },
  { value: "-$2,499 to $2,499", label: "-$2,499 to $2,499" },
  { value: "$2,500 to $24,999", label: "$2,500 to $24,999" },
  { value: "$25,000 to $49,999", label: "$25,000 to $49,999" },
  { value: "$50,000 to $74,999", label: "$50,000 to $74,999" },
  { value: "$75,000 to $99,999", label: "$75,000 to $99,999" },
  { value: "$100,000 to $149,999", label: "$100,000 to $149,999" },
  { value: "$150,000 to $249,999", label: "$150,000 to $249,999" },
  { value: "$250,000 to $374,999", label: "$250,000 to $374,999" },
  { value: "$375,000 to $499,999", label: "$375,000 to $499,999" },
  { value: "$500,000 to $749,999", label: "$500,000 to $749,999" },
  { value: "$750,000 to $999,999", label: "$750,000 to $999,999" },
  { value: "more than $1,000,000", label: "More than $1,000,000" },
];

// Credit rating options (from Audience API)
export const creditRatingOptions = [
  { value: "800+", label: "800+" },
  { value: "750 - 799", label: "750 - 799" },
  { value: "700 - 749", label: "700 - 749" },
  { value: "650 - 699", label: "650 - 699" },
  { value: "600 - 649", label: "600 - 649" },
  { value: "550 - 599", label: "550 - 599" },
  { value: "500 - 549", label: "500 - 549" },
  { value: "under 499", label: "Under 499" },
];

// New credit range options (from Audience API)
export const newCreditRangeOptions = [
  { value: "$0 - $100", label: "$0 - $100" },
  { value: "$101 - $300", label: "$101 - $300" },
  { value: "$301 - $500", label: "$301 - $500" },
  { value: "$501 - $1,000", label: "$501 - $1,000" },
  { value: "$1,001 - $3,000", label: "$1,001 - $3,000" },
  { value: "$3,001 - $5,000", label: "$3,001 - $5,000" },
  { value: "$5,001 - $9,999", label: "$5,001 - $9,999" },
  { value: "Greater than $9,999", label: "Greater than $9,999" },
];

// Credit card user options (from Audience API)
export const creditCardUserOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

// Investment options (from Audience API)
export const investmentOptions = [{ value: "investor", label: "Investor" }];

// Mortgage amount options (from Audience API) - uses min/max format
// Values stored as "min-max" for easy parsing, displayed as labels
export const mortgageAmountOptions = [
  { value: "0-50000", label: "$0 - $50,000", min: 0, max: 50000 },
  {
    value: "50001-100000",
    label: "$50,001 - $100,000",
    min: 50001,
    max: 100000,
  },
  {
    value: "100001-150000",
    label: "$100,001 - $150,000",
    min: 100001,
    max: 150000,
  },
  {
    value: "150001-200000",
    label: "$150,001 - $200,000",
    min: 150001,
    max: 200000,
  },
  {
    value: "200001-300000",
    label: "$200,001 - $300,000",
    min: 200001,
    max: 300000,
  },
  {
    value: "300001-500000",
    label: "$300,001 - $500,000",
    min: 300001,
    max: 500000,
  },
  {
    value: "500001-750000",
    label: "$500,001 - $750,000",
    min: 500001,
    max: 750000,
  },
  {
    value: "750001-1000000",
    label: "$750,001 - $1,000,000",
    min: 750001,
    max: 1000000,
  },
  {
    value: "1000001-1500000",
    label: "$1,000,001 - $1,500,000",
    min: 1000001,
    max: 1500000,
  },
  {
    value: "1500001-2000000",
    label: "$1,500,001 - $2,000,000",
    min: 1500001,
    max: 2000000,
  },
  {
    value: "2000001-3000000",
    label: "$2,000,001 - $3,000,000",
    min: 2000001,
    max: 3000000,
  },
  {
    value: "3000001-5000000",
    label: "$3,000,001 - $5,000,000",
    min: 3000001,
    max: 5000000,
  },
  {
    value: "5000001-7500000",
    label: "$5,000,001 - $7,500,000",
    min: 5000001,
    max: 7500000,
  },
  {
    value: "7500001-10000000",
    label: "$7,500,001 - $10,000,000",
    min: 7500001,
    max: 10000000,
  },
  {
    value: "10000001-15000000",
    label: "$10,000,001 - $15,000,000",
    min: 10000001,
    max: 15000000,
  },
  {
    value: "15000001-20000000",
    label: "$15,000,001 - $20,000,000",
    min: 15000001,
    max: 20000000,
  },
  {
    value: "20000001-30000000",
    label: "$20,000,001 - $30,000,000",
    min: 20000001,
    max: 30000000,
  },
  {
    value: "30000001-999999999",
    label: "$30,000,001+",
    min: 30000001,
    max: 999999999,
  },
];

// Occupation group options (from Audience API)
export const occupationGroupOptions = [
  { value: "professional / technical", label: "Professional / Technical" },
  {
    value: "administration / managerial",
    label: "Administration / Managerial",
  },
  { value: "sales / service", label: "Sales / Service" },
  { value: "clerical / white collar", label: "Clerical / White Collar" },
  { value: "craftsman / blue collar", label: "Craftsman / Blue Collar" },
  { value: "student", label: "Student" },
  { value: "homemaker", label: "Homemaker" },
  { value: "retired", label: "Retired" },
  { value: "farmer", label: "Farmer" },
  { value: "military", label: "Military" },
  { value: "religious", label: "Religious" },
  { value: "self employed", label: "Self Employed" },
  {
    value: "self employed - professional / technical",
    label: "Self Employed - Professional / Technical",
  },
  {
    value: "self employed - administration / managerial",
    label: "Self Employed - Administration / Managerial",
  },
  {
    value: "self employed - sales / service",
    label: "Self Employed - Sales / Service",
  },
  {
    value: "self employed - clerical / white collar",
    label: "Self Employed - Clerical / White Collar",
  },
  {
    value: "self employed - craftsman / blue collar",
    label: "Self Employed - Craftsman / Blue Collar",
  },
  { value: "self employed - student", label: "Self Employed - Student" },
  { value: "self employed - homemaker", label: "Self Employed - Homemaker" },
  { value: "self employed - retired", label: "Self Employed - Retired" },
  { value: "self employed - other", label: "Self Employed - Other" },
  { value: "educator", label: "Educator" },
  { value: "financial professional", label: "Financial Professional" },
  { value: "legal professional", label: "Legal Professional" },
  { value: "medical professional", label: "Medical Professional" },
  { value: "other", label: "Other" },
];

// CRA code options (from Audience API)
export const craCodeOptions = [
  { value: "low income", label: "Low Income" },
  { value: "moderate income", label: "Moderate Income" },
  { value: "middle income", label: "Middle Income" },
  { value: "high income", label: "High Income" },
];

// Yes/No options for boolean filters
export const yesNoOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

// Ethnicity options (from Audience API)
export const ethnicityOptions = [
  { value: "afghani", label: "Afghani" },
  { value: "african american 1", label: "African American" },
  { value: "african american 2", label: "African American 2" },
  { value: "albanian", label: "Albanian" },
  { value: "algerian", label: "Algerian" },
  { value: "arab", label: "Arab" },
  { value: "armenian", label: "Armenian" },
  { value: "australian", label: "Australian" },
  { value: "austrian", label: "Austrian" },
  { value: "basque", label: "Basque" },
  { value: "belgian", label: "Belgian" },
  { value: "bengladesh", label: "Bangladesh" },
  { value: "bosnian", label: "Bosnian" },
  { value: "bulgarian", label: "Bulgarian" },
  { value: "caribbean african american", label: "Caribbean African American" },
  { value: "chinese", label: "Chinese" },
  { value: "croatian", label: "Croatian" },
  { value: "czech", label: "Czech" },
  { value: "danish", label: "Danish" },
  { value: "dutch", label: "Dutch" },
  { value: "egyptian", label: "Egyptian" },
  { value: "english", label: "English" },
  { value: "estonian", label: "Estonian" },
  { value: "ethiopian", label: "Ethiopian" },
  { value: "filipino", label: "Filipino" },
  { value: "finnish", label: "Finnish" },
  { value: "french", label: "French" },
  { value: "german", label: "German" },
  { value: "greek", label: "Greek" },
  { value: "hawaiian", label: "Hawaiian" },
  { value: "hispanic", label: "Hispanic" },
  { value: "hungarian", label: "Hungarian" },
  { value: "icelandic", label: "Icelandic" },
  { value: "indian", label: "Indian" },
  { value: "indonesian", label: "Indonesian" },
  { value: "iraqi", label: "Iraqi" },
  { value: "irish", label: "Irish" },
  { value: "italian", label: "Italian" },
  { value: "japanese", label: "Japanese" },
  { value: "jewish", label: "Jewish" },
  { value: "korean", label: "Korean" },
  { value: "latvian", label: "Latvian" },
  { value: "lithuanian", label: "Lithuanian" },
  { value: "macedonian", label: "Macedonian" },
  { value: "malay", label: "Malay" },
  { value: "moroccan", label: "Moroccan" },
  { value: "multi-ethnic", label: "Multi-Ethnic" },
  { value: "native american", label: "Native American" },
  { value: "new zealand", label: "New Zealand" },
  { value: "nigerian", label: "Nigerian" },
  { value: "norwegian", label: "Norwegian" },
  { value: "pakistani", label: "Pakistani" },
  { value: "persian", label: "Persian" },
  { value: "polish", label: "Polish" },
  { value: "portuguese", label: "Portuguese" },
  { value: "romanian", label: "Romanian" },
  { value: "russian", label: "Russian" },
  { value: "saudi", label: "Saudi" },
  { value: "scotch", label: "Scottish" },
  { value: "serbian", label: "Serbian" },
  { value: "slovakian", label: "Slovakian" },
  { value: "slovenian", label: "Slovenian" },
  { value: "somali", label: "Somali" },
  { value: "south african", label: "South African" },
  { value: "sri lankan", label: "Sri Lankan" },
  { value: "swedish", label: "Swedish" },
  { value: "swiss", label: "Swiss" },
  { value: "syrian", label: "Syrian" },
  { value: "thai", label: "Thai" },
  { value: "turkish", label: "Turkish" },
  { value: "ukrainian", label: "Ukrainian" },
  { value: "vietnamese", label: "Vietnamese" },
  { value: "welsh", label: "Welsh" },
];

// Language options (from Audience API)
export const languageOptions = [
  { value: "arabic", label: "Arabic" },
  {
    value: "chinese (mandarin, cantonese and other dialects)",
    label: "Chinese",
  },
  { value: "dutch", label: "Dutch" },
  { value: "english", label: "English" },
  { value: "farsi", label: "Farsi" },
  { value: "french", label: "French" },
  { value: "german", label: "German" },
  { value: "greek", label: "Greek" },
  { value: "hebrew", label: "Hebrew" },
  { value: "hindi", label: "Hindi" },
  { value: "hungarian", label: "Hungarian" },
  { value: "italian", label: "Italian" },
  { value: "japanese", label: "Japanese" },
  { value: "korean", label: "Korean" },
  { value: "polish", label: "Polish" },
  { value: "portuguese", label: "Portuguese" },
  { value: "russian", label: "Russian" },
  { value: "spanish", label: "Spanish" },
  { value: "tagalog", label: "Tagalog" },
  { value: "thai", label: "Thai" },
  { value: "turkish", label: "Turkish" },
  { value: "urdu", label: "Urdu" },
  { value: "vietnamese", label: "Vietnamese" },
];

// Education options (from Audience API)
export const educationOptions = [
  { value: "high school", label: "High School" },
  { value: "bachelor's", label: "Bachelor's" },
  { value: "master's", label: "Master's" },
  { value: "doctorate", label: "Doctorate" },
];

// Smoker options (from Audience API)
export const smokerOptions = [
  { value: "smoker", label: "Smoker" },
  { value: "non-smoker", label: "Non-Smoker" },
];

// Dwelling type options (from Audience API)
export const dwellingTypeOptions = [
  { value: "multi-family", label: "Multi-Family" },
  { value: "single-family", label: "Single-Family" },
];

// Contact notNulls options (from Audience API)
export const contactNotNullsOptions = [
  {
    value: "PERSONAL_EMAILS_VALIDATION_STATUS",
    label: "Verified Personal Emails",
  },
  {
    value: "BUSINESS_EMAILS_VALIDATION_STATUS",
    label: "Verified Business Emails",
  },
  { value: "VALID_PHONES", label: "Valid Phones" },
  {
    value: "SKIPTRACE_WIRELESS_NUMBERS",
    label: "Skip Traced Wireless Phone Number",
  },
  {
    value: "SKIPTRACE_B2B_PHONE",
    label: "Skip Traced Wireless B2B Phone Number",
  },
];

// Estimated home value options (from Audience API)
export const estimatedHomeValueOptions = [
  { value: "$1,000 - $24,999", label: "$1,000 - $24,999" },
  { value: "$25,000 - $49,999", label: "$25,000 - $49,999" },
  { value: "$50,000 - $74,999", label: "$50,000 - $74,999" },
  { value: "$75,000 - $99,999", label: "$75,000 - $99,999" },
  { value: "$100,000 - $124,999", label: "$100,000 - $124,999" },
  { value: "$125,000 - $149,999", label: "$125,000 - $149,999" },
  { value: "$150,000 - $174,999", label: "$150,000 - $174,999" },
  { value: "$175,000 - $199,999", label: "$175,000 - $199,999" },
  { value: "$200,000 - $224,999", label: "$200,000 - $224,999" },
  { value: "$225,000 - $249,999", label: "$225,000 - $249,999" },
  { value: "$250,000 - $274,999", label: "$250,000 - $274,999" },
  { value: "$275,000 - $299,999", label: "$275,000 - $299,999" },
  { value: "$300,000 - $349,999", label: "$300,000 - $349,999" },
  { value: "$350,000 - $399,999", label: "$350,000 - $399,999" },
  { value: "$400,000 - $449,999", label: "$400,000 - $449,999" },
  { value: "$450,000 - $499,999", label: "$450,000 - $499,999" },
  { value: "$500,000 - $749,999", label: "$500,000 - $749,999" },
  { value: "$750,000 - $999,999", label: "$750,000 - $999,999" },
  { value: "$1,000,000 plus", label: "$1,000,000+" },
];

// SIC codes from Audience API
export const sicCodeOptions = [
  "8011",
  "7389",
  "8221",
  "8211",
  "8742",
  "8062",
  "6531",
  "7371",
  "5812",
  "6411",
  "8741",
  "8111",
  "7372",
  "6021",
  "8711",
  "8748",
  "7361",
  "7011",
  "8322",
  "8043",
  "9711",
  "4813",
  "7379",
  "6211",
  "2834",
  "9111",
  "6282",
  "5311",
  "5411",
  "6022",
  "8721",
  "7374",
  "9223",
  "5999",
  "7373",
  "4731",
  "7311",
  "8731",
  "6719",
  "8099",
  "5961",
  "5511",
  "1521",
  "4911",
  "6311",
  "8661",
  "1731",
  "7999",
  "8641",
  "6799",
  "8049",
  "5084",
  "3571",
  "6331",
  "5912",
  "5734",
  "8351",
  "4213",
  "8082",
  "5045",
  "8699",
  "8299",
  "8042",
  "8093",
  "3674",
  "6141",
  "6324",
  "6321",
  "3714",
  "8222",
  "6512",
  "8399",
  "7363",
  "6162",
  "3841",
  "8732",
  "5621",
  "2711",
  "8712",
  "4812",
  "9199",
  "3812",
  "1542",
  "8733",
  "1711",
  "4833",
  "1799",
  "8051",
  "5211",
  "7299",
  "7375",
  "5099",
  "6513",
  "3999",
  "3711",
  "3577",
  "4512",
  "5731",
  "9431",
  "5065",
  "4225",
  "3663",
  "5651",
  "1311",
  "4841",
  "5399",
  "4899",
  "5063",
  "7991",
  "2741",
  "5122",
  "4724",
  "5141",
  "6061",
  "9221",
  "5085",
  "3089",
  "6722",
  "7699",
  "1389",
  "4832",
  "5047",
  "8999",
  "7382",
  "5963",
  "3721",
  "7359",
  "3842",
  "6159",
  "8231",
  "6733",
  "5199",
  "8611",
  "7349",
  "5541",
  "8071",
  "8621",
  "7538",
  "8361",
  "7997",
  "5149",
  "5531",
  "5712",
  "7381",
  "5942",
  "9311",
  "7231",
  "9224",
  "5499",
  "8713",
  "8021",
  "6794",
  "5169",
  "7812",
  "5941",
  "7941",
  "3826",
  "6029",
  "5044",
  "6552",
  "5331",
  "2844",
  "7929",
  "5947",
  "5012",
  "5046",
  "3724",
  "3728",
  "2759",
  "9441",
  "2731",
  "8069",
  "5661",
  "8743",
  "6399",
  "2721",
  "2899",
  "5611",
  "5072",
  "3599",
  "7922",
  "8734",
  "2752",
  "4953",
  "7629",
  "9621",
  "4212",
  "9451",
  "5031",
  "2099",
  "4111",
  "2821",
  "2869",
  "4581",
  "2835",
  "2911",
  "9512",
  "2086",
  "7336",
  "4311",
  "6163",
  "5082",
  "1623",
  "8412",
  "1382",
  "1541",
  "4119",
  "7378",
  "7514",
  "5172",
  "5719",
  "4215",
  "5013",
  "3625",
  "3575",
  "6732",
  "6153",
  "3572",
  "6712",
  "8331",
  "5944",
  "9121",
  "7319",
  "2819",
  "3679",
  "5049",
  "3699",
  "5992",
  "2621",
  "3829",
  "4941",
  "9721",
  "1522",
  "5051",
  "1611",
  "4513",
  "5461",
  "3559",
  "1629",
  "7334",
  "4789",
  "7291",
  "9211",
  "5813",
  "9611",
  "5943",
  "5191",
  "6798",
  "5083",
  "3823",
  "8059",
  "3825",
  "5945",
  "5632",
  "5112",
  "9511",
  "6099",
  "2841",
  "7532",
  "3761",
  "0742",
  "5251",
  "4924",
  "5699",
  "3561",
  "3533",
  "5074",
  "3312",
  "1381",
  "7992",
  "2836",
  "4931",
  "3672",
  "4491",
  "3993",
  "2891",
  "5932",
  "3585",
  "5087",
  "2531",
  "3652",
  "8811",
  "8052",
  "8249",
  "9641",
  "1761",
  "5088",
  "4522",
  "5021",
  "7032",
  "7513",
  "3531",
  "5136",
  "1531",
  "0781",
  "8041",
  "2431",
  "8631",
  "2052",
  "6361",
  "7323",
  "7331",
  "8744",
  "6035",
  "0782",
  "5182",
  "5023",
  "5722",
  "5153",
  "3949",
  "3523",
  "9222",
  "3845",
  "3441",
  "2879",
  "7819",
  "1751",
  "6111",
  "2084",
  "6519",
  "3491",
  "6062",
  "8092",
  "3661",
  "3511",
  "5137",
  "1742",
  "7322",
  "1794",
  "2851",
  "9411",
  "2024",
  "9651",
  "5091",
  "1721",
  "4011",
  "6726",
  "5075",
  "3751",
  "6351",
  "1743",
  "0191",
  "5995",
  "3731",
  "3613",
  "3469",
  "9531",
  "2782",
  "5713",
  "4121",
  "3444",
  "5231",
  "4922",
  "5521",
  "6541",
  "7313",
  "2048",
  "4729",
  "7539",
  "7353",
  "7996",
  "1771",
  "3272",
  "2015",
  "9229",
  "2329",
  "3643",
  "5113",
  "7342",
  "7376",
  "5032",
  "2653",
  "9661",
  "2842",
  "3499",
  "3443",
  "3621",
  "3317",
  "5148",
  "2022",
  "4725",
  "7221",
  "2833",
  "3589",
  "7549",
  "0752",
  "3429",
  "7993",
  "7521",
  "3646",
  "3651",
  "5064",
  "5078",
  "5139",
  "4226",
  "3398",
  "7832",
  "1791",
  "3273",
  "2082",
  "7822",
  "3544",
  "8063",
  "5094",
  "4493",
  "5092",
  "3569",
  "3069",
  "5181",
  "6371",
  "3442",
  "9532",
  "2051",
  "3291",
  "5052",
  "2813",
  "5192",
  "2041",
  "3546",
  "2631",
  "2023",
  "5093",
  "3535",
  "6036",
  "3021",
  "5946",
  "3669",
  "3579",
  "2011",
  "1752",
  "5921",
  "3851",
  "3827",
  "2421",
  "6082",
  "3713",
  "3011",
  "4939",
  "1741",
  "3944",
  "4214",
  "3822",
  "5736",
  "2033",
  "2087",
  "5949",
  "2026",
  "7383",
  "1796",
  "2843",
  "6081",
  "3519",
  "7335",
  "3563",
  "3465",
  "5641",
  "2389",
  "7542",
  "2676",
  "3081",
  "7841",
  "3861",
  "7352",
  "3479",
  "8243",
  "9999",
  "3648",
  "3843",
  "8031",
  "4499",
  "9131",
  "3357",
  "5571",
  "3678",
  "3537",
  "7911",
  "4932",
  "2038",
  "7623",
  "4612",
  "0783",
  "3545",
  "3471",
  "2671",
  "7261",
  "2325",
  "7338",
  "2434",
  "3568",
  "5131",
  "5143",
  "5171",
  "7384",
  "7241",
  "3694",
  "3565",
  "2672",
  "3691",
  "2043",
  "2326",
  "3556",
  "5735",
  "2599",
  "5033",
  "4959",
  "1622",
  "9631",
  "3423",
  "2273",
  "5261",
  "2673",
  "3432",
  "5147",
  "4151",
  "3541",
  "3221",
  "8651",
  "5948",
  "5014",
  "5551",
  "2064",
  "8422",
  "5142",
  "3053",
  "6011",
  "6221",
  "2522",
  "4952",
  "3578",
  "3612",
  "3799",
  "8244",
  "7218",
  "3594",
  "3564",
  "2396",
  "3555",
  "3462",
  "2679",
  "2771",
  "1241",
  "2399",
  "2512",
  "5145",
  "3086",
  "7948",
  "5561",
  "3494",
  "6553",
  "5193",
  "3593",
  "2789",
  "4412",
  "2066",
  "3732",
  "3231",
  "3821",
  "6289",
  "3448",
  "5983",
  "3911",
  "1793",
  "3542",
  "8072",
  "3411",
  "5043",
  "1442",
  "3844",
  "2085",
  "3446",
  "3355",
  "2013",
  "5039",
  "2339",
  "0751",
  "6231",
  "3532",
  "3633",
  "4222",
  "7041",
  "3743",
  "3562",
  "5111",
  "5962",
  "2499",
  "5599",
  "2541",
  "2521",
  "3229",
  "3496",
  "2511",
  "3492",
  "4481",
  "3433",
  "3399",
  "2812",
  "5162",
  "3241",
  "2211",
  "5984",
  "5441",
  "3498",
  "4961",
  "7217",
  "2796",
  "3351",
  "3296",
  "3325",
  "3334",
  "5146",
  "3639",
  "7216",
  "2079",
  "5993",
  "3629",
  "3645",
  "2092",
  "3211",
  "7515",
  "0181",
  "2321",
  "7692",
  "2542",
  "0723",
  "5271",
  "4449",
  "7213",
  "0741",
  "3824",
  "3534",
  "2221",
  "2515",
  "3316",
  "3695",
  "5194",
  "3634",
  "2037",
  "3549",
  "7033",
  "2074",
  "4142",
  "3449",
  "2992",
  "4923",
  "3354",
  "4619",
  "0762",
  "3452",
  "5015",
  "2047",
  "1041",
  "2754",
  "2873",
  "3356",
  "0291",
  "2435",
  "7312",
  "3341",
  "3715",
  "3315",
  "3143",
  "1021",
  "2361",
  "2032",
  "5159",
  "2448",
  "2111",
  "1781",
  "5421",
  "7536",
  "0115",
  "3764",
  "3592",
  "2952",
  "5994",
  "3271",
  "1422",
  "1795",
  "3548",
  "4013",
  "7021",
  "4221",
  "3431",
  "3451",
  "3524",
  "3052",
  "7622",
  "2095",
  "1321",
  "0119",
  "5144",
  "4489",
  "2096",
  "2452",
  "3321",
  "3677",
  "3566",
  "3339",
  "2395",
  "2951",
  "7212",
  "1221",
  "2035",
  "3171",
  "4822",
  "6514",
  "3644",
  "2822",
  "3631",
  "3931",
  "3567",
  "3324",
  "2893",
  "3253",
  "5431",
  "0721",
  "2791",
  "2311",
  "3536",
  "3353",
  "3554",
  "7933",
  "3484",
  "3275",
  "6091",
  "7519",
  "3647",
  "6515",
  "2331",
  "2335",
  "2426",
  "3369",
  "2254",
  "5198",
  "4131",
  "2075",
  "2514",
  "5451",
  "3085",
  "3084",
  "3251",
  "2874",
  "4783",
  "2591",
  "3873",
  "5989",
  "2656",
  "2611",
  "4785",
  "3083",
  "2299",
  "3635",
  "2253",
  "2295",
  "3281",
  "0211",
  "7537",
  "5048",
  "3942",
  "2392",
  "2732",
  "4925",
  "5154",
  "7694",
  "3641",
  "2439",
  "2394",
  "4971",
  "3421",
  "2493",
  "7829",
  "3149",
  "3131",
  "3463",
  "2761",
  "3671",
  "2341",
  "0241",
  "0851",
  "3061",
  "1081",
  "3292",
  "2281",
  "3297",
  "3363",
  "2034",
  "2865",
  "4492",
  "7377",
  "3269",
  "3365",
  "3493",
  "3792",
  "7211",
  "2045",
  "3624",
  "2046",
  "3489",
  "2451",
  "3965",
  "3692",
  "2077",
  "1011",
  "2892",
  "3412",
  "3483",
  "3596",
  "3795",
  "0139",
  "1423",
  "0213",
  "0161",
  "0175",
  "2657",
  "1099",
  "7534",
  "3632",
  "2261",
  "2131",
  "3425",
  "0971",
  "3553",
  "2491",
  "3088",
  "2895",
  "2297",
  "0212",
  "2411",
  "2252",
  "2068",
  "7533",
  "3082",
  "7215",
  "2675",
  "3161",
  "3961",
  "2677",
  "3482",
  "4424",
  "0811",
  "3769",
  "2337",
  "3675",
  "2241",
  "3295",
  "3366",
  "3087",
  "3676",
  "4141",
  "3495",
  "2449",
  "3199",
  "3172",
  "3144",
  "3274",
  "2053",
  "3716",
  "0172",
  "3951",
  "2875",
  "4613",
  "2824",
  "3299",
  "2436",
  "4173",
  "3331",
  "2021",
  "2655",
  "1479",
  "3466",
  "2091",
  "7219",
  "5714",
  "1446",
  "3552",
  "1499",
  "3953",
  "4741",
  "2519",
  "2441",
  "7641",
  "2678",
  "3255",
  "3264",
  "3313",
  "0254",
  "3497",
  "4231",
  "3586",
  "2353",
  "2393",
  "3582",
  "1455",
  "3142",
  "2816",
  "3995",
  "2098",
  "3364",
  "0252",
  "0131",
  "0279",
  "0134",
  "2323",
  "1429",
  "0111",
  "2652",
  "2067",
  "2298",
  "3581",
  "3915",
  "0174",
  "2063",
  "2284",
  "2062",
  "1481",
  "3955",
  "3543",
  "3991",
  "0711",
  "2097",
  "2044",
  "2674",
  "0272",
  "0921",
  "2391",
  "2381",
  "4482",
  "0182",
  "2369",
  "3996",
  "1222",
  "1411",
  "2861",
  "3952",
  "1459",
  "2061",
  "3914",
  "2251",
  "1094",
  "0831",
  "3261",
  "2121",
  "2823",
  "3547",
  "2231",
  "1031",
  "3111",
  "0179",
  "0251",
  "0171",
  "2258",
  "0722",
  "0761",
  "2262",
  "2999",
  "1474",
  "6792",
  "6019",
  "2296",
  "7631",
  "0173",
  "0116",
  "2269",
  "2342",
  "0132",
  "2259",
  "3322",
  "2386",
  "4432",
  "2429",
  "2385",
  "2282",
  "0273",
  "2141",
  "3259",
  "2083",
  "2257",
  "1044",
  "0912",
  "3263",
  "1061",
  "2322",
  "0219",
  "3151",
  "0133",
  "2517",
  "0259",
  "7251",
  "7833",
  "2387",
  "2384",
  "3262",
  "2076",
  "0253",
  "0724",
  "0919",
  "0913",
  "0271",
  "0112",
  "0214",
  "1475",
  "2371",
  "2397",
  "6517",
];

// NAICS codes from Audience API
export const naicsCodeOptions = [
  "62",
  "44",
  "52",
  "5415",
  "6113",
  "5112",
  "92",
  "621111",
  "531",
  "236",
  "92311",
  "524",
  "722",
  "541613",
  "813400",
  "3361",
  "541110",
  "6111",
  "517",
  "5416",
  "7211",
  "7225",
  "531210",
  "484",
  "541612",
  "92811",
  "52211",
  "561110",
  "211",
  "54111",
  "5412",
  "71394",
  "335",
  "31",
  "81",
  "71",
  "3254",
  "3391",
  "621",
  "541714",
  "333",
  "336414",
  "325",
  "541519",
  "611110",
  "3332",
  "481",
  "22",
  "54162",
  "6241",
  "621399",
  "523120",
  "237",
  "42",
  "523150",
  "3364",
  "62133",
  "515",
  "448",
  "4233",
  "999990",
  "813110",
  "54131",
  "8131",
  "5414",
  "5417",
  "5612",
  "621210",
  "8134",
  "722511",
  "7112",
  "524210",
  "334",
  "541618",
  "541512",
  "518210",
  "624190",
  "522110",
  "5616",
  "111998",
  "236116",
  "48",
  "212",
  "5615",
  "511",
  "561990",
  "5411",
  "3344",
  "56192",
  "326112",
  "531311",
  "541611",
  "541330",
  "92212",
  "492",
  "541511",
  "511210",
  "5239",
  "333249",
  "611310",
  "611710",
  "443142",
  "921120",
  "3341",
  "337",
  "522293",
  "423990",
  "323",
  "32562",
  "541219",
  "238220",
  "33441",
  "6114",
  "71113",
  "92219",
  "45321",
  "519210",
  "7115",
  "712110",
  "339999",
  "54182",
  "519130",
  "621999",
  "111",
  "517121",
  "3121",
  "712",
  "3261",
  "813319",
  "7132",
  "238210",
  "622110",
  "52391",
  "541820",
  "523930",
  "517919",
  "92812",
  "551112",
  "236115",
  "323111",
  "541810",
  "811210",
  "51111",
  "523940",
  "813910",
  "541940",
  "423830",
  "721110",
  "561499",
  "713",
  "441110",
  "624410",
  "313",
  "449210",
  "811111",
  "517110",
  "561730",
  "522291",
  "52311",
  "54192",
  "322",
  "531110",
  "44511",
  "611699",
  "92111",
  "54191",
  "423610",
  "54194",
  "455219",
  "522130",
  "722310",
  "221118",
  "621340",
  "561311",
  "4483",
  "237310",
  "541614",
  "484121",
  "236220",
  "236118",
  "325412",
  "238990",
  "524126",
  "517911",
  "483",
  "522292",
  "921110",
  "523110",
  "423450",
  "423690",
  "458110",
  "541715",
  "812112",
  "424490",
  "541310",
  "551111",
  "519120",
  "453998",
  "813990",
  "3365",
  "56141",
  "451140",
  "713940",
  "621310",
  "813410",
  "621320",
  "541990",
  "92211",
  "811412",
  "541211",
  "221310",
  "33992",
  "112511",
  "334511",
  "451120",
  "311999",
  "922120",
  "332710",
  "441120",
  "336110",
  "511110",
  "339112",
  "459210",
  "237210",
  "446110",
  "456110",
  "441330",
  "541720",
  "811212",
  "623110",
  "517810",
  "531190",
  "621610",
  "54193",
  "517210",
  "425120",
  "213112",
  "513110",
  "561621",
  "523910",
  "561510",
  "541711",
  "522390",
  "221122",
  "922160",
  "623990",
  "334111",
  "541910",
  "488510",
  "551114",
  "454111",
  "238160",
  "423820",
  "512",
  "621330",
  "327",
  "515210",
  "334220",
  "531320",
  "8139",
  "54172",
  "334419",
  "561720",
  "522310",
  "424210",
  "621493",
  "8132",
  "423430",
  "517312",
  "541921",
  "541690",
  "444190",
  "522298",
  "541191",
  "444140",
  "812990",
  "325414",
  "51219",
  "513199",
  "423420",
  "423840",
  "339950",
  "424690",
  "457120",
  "336390",
  "115210",
  "921130",
  "484230",
  "493110",
  "448140",
  "443120",
  "451211",
  "444110",
  "523",
  "488119",
  "621511",
  "622210",
  "238110",
  "451110",
  "541213",
  "221210",
  "238320",
  "517111",
  "481111",
  "515112",
  "515120",
  "445299",
  "455110",
  "485119",
  "561612",
  "524114",
  "921",
  "442110",
  "424720",
  "453220",
  "441310",
  "448120",
  "333998",
  "459999",
  "445131",
  "512110",
  "611210",
  "444130",
  "711510",
  "921190",
  "237110",
  "334413",
  "516110",
  "423310",
  "531120",
  "449110",
  "484110",
  "812210",
  "561920",
  "511199",
  "621112",
  "811121",
  "325998",
  "333999",
  "524128",
  "336350",
  "711410",
  "541430",
  "424410",
  "423510",
  "115116",
  "516120",
  "424910",
  "447190",
  "624110",
  "444180",
  "333514",
  "621391",
  "524113",
  "928110",
  "423850",
  "541320",
  "623311",
  "424990",
  "923130",
  "446120",
  "531390",
  "813211",
  "524298",
  "511120",
  "561440",
  "561320",
  "459110",
  "459510",
  "336111",
  "624310",
  "453310",
  "456120",
  "441222",
  "516210",
  "492110",
  "211120",
  "713990",
  "112990",
  "332312",
  "332999",
  "441320",
  "423720",
  "459420",
  "444240",
  "3366",
  "523991",
  "441340",
  "488190",
  "423810",
  "922110",
  "811114",
  "337110",
  "541410",
  "485999",
  "458310",
  "722410",
  "445120",
  "335999",
  "238350",
  "541380",
  "448310",
  "423710",
  "92112",
  "532490",
  "152106",
  "448210",
  "611610",
  "311811",
  "423930",
  "561613",
  "444220",
  "517112",
  "423210",
  "611519",
  "621910",
  "311111",
  "423320",
  "541860",
  "541890",
  "423490",
  "531312",
  "541370",
  "811490",
  "442299",
  "922130",
  "3115",
  "453910",
  "561710",
  "485410",
  "523999",
  "448190",
  "623312",
  "331110",
  "212390",
  "52239",
  "238310",
  "486110",
  "453210",
  "453110",
  "458210",
  "452111",
  "336411",
  "561312",
  "441228",
  "926120",
  "238140",
  "813930",
  "721310",
  "811219",
  "522320",
  "561520",
  "924120",
  "443141",
  "311351",
  "511130",
  "332812",
  "524291",
  "3122",
  "423110",
  "445298",
  "813920",
  "211111",
  "561422",
  "481112",
  "926130",
  "323113",
  "813311",
  "332119",
  "441227",
  "334290",
  "722513",
  "561599",
  "424420",
  "324110",
  "459410",
  "811310",
  "452990",
  "532111",
  "424480",
  "1121",
  "423860",
  "115310",
  "326122",
  "531130",
  "541713",
  "459910",
  "722320",
  "312111",
  "926110",
  "713930",
  "713290",
  "561910",
  "445320",
  "445230",
  "444120",
  "334519",
  "812921",
  "449129",
  "513120",
  "712190",
  "445310",
  "311513",
  "446130",
  "459310",
  "61",
  "238190",
  "423120",
  "213111",
  "923120",
  "238290",
  "81299",
  "1141",
  "721211",
  "314999",
  "423440",
  "336413",
  "485310",
  "621498",
  "238330",
  "561740",
  "454113",
  "711190",
  "522210",
  "335311",
  "446199",
  "523920",
  "332322",
  "448150",
  "443112",
  "611620",
  "325211",
  "311611",
  "424810",
  "562212",
  "525990",
  "423220",
  "541214",
  "321918",
  "237130",
  "446191",
  "333120",
  "311119",
  "327390",
  "452210",
  "484210",
  "335312",
  "315990",
  "312130",
  "812199",
  "519190",
  "333413",
  "922190",
  "926140",
  "925120",
  "541870",
  "336611",
  "423730",
  "486210",
  "624120",
  "812910",
  "334513",
  "524127",
  "561330",
  "339920",
  "424120",
  "485210",
  "321113",
  "532120",
  "51",
  "424110",
  "493130",
  "722515",
  "448110",
  "721199",
  "423390",
  "334310",
  "924110",
  "812220",
  "454110",
  "326299",
  "311812",
  "922150",
  "323119",
  "423460",
  "327320",
  "521110",
  "811192",
  "722213",
  "312120",
  "238340",
  "517311",
  "339113",
  "333318",
  "488410",
  "42343",
  "812320",
  "454390",
  "445210",
  "423940",
  "459120",
  "532310",
  "541922",
  "811118",
  "525910",
  "525110",
  "812113",
  "322220",
  "339116",
  "334210",
  "488210",
  "333415",
  "322121",
  "332813",
  "333414",
  "532289",
  "337127",
  "424320",
  "713110",
  "323110",
  "522299",
  "928120",
  "611430",
  "533110",
  "423620",
  "532412",
  "524292",
  "111421",
  "445240",
  "611512",
  "812930",
  "711310",
  "23822",
  "336999",
  "333912",
  "326211",
  "811198",
  "423920",
  "332994",
  "334516",
  "333111",
  "812111",
  "333517",
  "321999",
  "562219",
  "813212",
  "339991",
  "624221",
  "44312",
  "562211",
  "56131",
  "562119",
  "561421",
  "334510",
  "512120",
  "212399",
  "424820",
  "522120",
  "112120",
  "334118",
  "532411",
  "322120",
  "332313",
  "332618",
  "325199",
  "424470",
  "621991",
  "325611",
  "423140",
  "52312",
  "487210",
  "423130",
  "493190",
  "561492",
  "337122",
  "334613",
  "519110",
  "322211",
  "334515",
  "424460",
  "62419",
  "482111",
  "611410",
  "483211",
  "335314",
  "486990",
  "333310",
  "23821",
  "444210",
  "441210",
  "424430",
  "424930",
  "561439",
  "334412",
  "713210",
  "311821",
  "485320",
  "334610",
  "237120",
  "236210",
  "541350",
  "331513",
  "333991",
  "334512",
  "453920",
  "333248",
  "562991",
  "311421",
  "532299",
  "324121",
  "541840",
  "113310",
  "221119",
  "451130",
  "561591",
  "56132",
  "333922",
  "332111",
  "321920",
  "326113",
  "711110",
  "512199",
  "333611",
  "513130",
  "334119",
  "541620",
  "321992",
  "452319",
  "811211",
  "488490",
  "621512",
  "337214",
  "339910",
  "541930",
  "312230",
  "52393",
  "423410",
  "512131",
  "327215",
  "481219",
  "923140",
  "54169",
  "485113",
  "611420",
  "333132",
  "238390",
  "456130",
  "522220",
  "721191",
  "621491",
  "459991",
  "333923",
  "711211",
  "332919",
  "331318",
  "325510",
  "511140",
  "53112",
  "813312",
  "812191",
  "5418",
  "51112",
  "489903",
  "23622",
  "456191",
  "321912",
  "453991",
  "624230",
  "311615",
  "331511",
  "459130",
  "325520",
  "238120",
  "311211",
  "622310",
  "333921",
  "332321",
  "485510",
  "325180",
  "523210",
  "561622",
  "52212",
  "311942",
  "322219",
  "327112",
  "332510",
  "332116",
  "451212",
  "335921",
  "325314",
  "488999",
  "445132",
  "333618",
  "923110",
  "325620",
  "721214",
  "333242",
  "925110",
  "532282",
  "339930",
  "325320",
  "311412",
  "445291",
  "332996",
  "423520",
  "311612",
  "459140",
  "332323",
  "532230",
  "812310",
  "334514",
  "325612",
  "541490",
  "337215",
  "52213",
  "424330",
  "49311",
  "333914",
  "325311",
  "452112",
  "42361",
  "56173",
  "53111",
  "926150",
  "336322",
  "313210",
  "811420",
  "333613",
  "541199",
  "424950",
  "458320",
  "335313",
  "327991",
  "621410",
  "333911",
  "813940",
  "811122",
  "522190",
  "313310",
  "424920",
  "442291",
  "238130",
  "611511",
  "212114",
  "524130",
  "336412",
  "333515",
  "423740",
  "541850",
  "114210",
  "45299",
  "334614",
  "311613",
  "331210",
  "221330",
  "515111",
  "23899",
  "448130",
  "42383",
  "711212",
  "454210",
  "335121",
  "333241",
  "525190",
  "611630",
  "327993",
  "454310",
  "339940",
  "72111",
  "44131",
  "212290",
  "712130",
  "561210",
  "336399",
  "331221",
  "212111",
  "713920",
  "212221",
  "327212",
  "326150",
  "621492",
  "33422",
  "213115",
  "541360",
  "333924",
  "327120",
  "81391",
  "453930",
  "48839",
  "019101",
  "561410",
  "333993",
  "336510",
  "311941",
  "314910",
  "325130",
  "333314",
  "336211",
  "424350",
  "334418",
  "221320",
  "56151",
  "51113",
  "152139",
  "42499",
  "335131",
  "323120",
  "488320",
  "921150",
  "424340",
  "212299",
  "488330",
  "336360",
  "485111",
  "54171",
  "325188",
  "54181",
  "325120",
  "271101",
  "611692",
  "332216",
  "813219",
  "424450",
  "315220",
  "327420",
  "42412",
  "312229",
  "332911",
  "42362",
  "921140",
  "339114",
  "332721",
  "541120",
  "336612",
  "327992",
  "711320",
  "811411",
  "44611",
  "441229",
  "336991",
  "424310",
  "424940",
  "42369",
  "327211",
  "713950",
  "332722",
  "333316",
  "332811",
  "562920",
  "315240",
  "213114",
  "53249",
  "312113",
  "459920",
  "335129",
  "812331",
  "334112",
  "573407",
  "541830",
  "111339",
  "423330",
  "561790",
  "327310",
  "211130",
  "333319",
  "424440",
  "51512",
  "326220",
  "334416",
  "561450",
  "486910",
  "52231",
  "48531",
  "493120",
  "518",
  "451220",
  "331523",
  "212311",
  "482",
  "44111",
  "448320",
  "325991",
  "42434",
  "337124",
  "311314",
  "326160",
  "811430",
  "332431",
  "512191",
  "333519",
  "238150",
  "424710",
  "487990",
  "326121",
  "32411",
  "512230",
  "52219",
  "449122",
  "111332",
  "44413",
  "331111",
  "811213",
  "111920",
  "541513",
  "311710",
  "334417",
  "315222",
  "45411",
  "331222",
  "523130",
  "313110",
  "323114",
  "332991",
  "324191",
  "333244",
  "335991",
  "212319",
  "333313",
  "322299",
  "115114",
  "179921",
  "333994",
  "452910",
  "312140",
  "311352",
  "334612",
  "331512",
  "316998",
  "323122",
  "54132",
  "22111",
  "532210",
  "711130",
  "331529",
  "811113",
  "314110",
  "322230",
  "722330",
  "115112",
  "811191",
  "562998",
  "337910",
  "484220",
  "238170",
  "42349",
  "23711",
  "523160",
  "32791",
  "424520",
  "311511",
  "23712",
  "31152",
  "333512",
  "42345",
  "48422",
  "212321",
  "336370",
  "331410",
  "513191",
  "335931",
  "332311",
  "523140",
  "6216",
  "311824",
  "325194",
  "273198",
  "333243",
  "325910",
  "029103",
  "44831",
  "336320",
  "321991",
  "152101",
  "316210",
  "532112",
  "532420",
  "331316",
  "459930",
  "443111",
  "179405",
  "323117",
  "332913",
  "332912",
  "332439",
  "33995",
  "333112",
  "335139",
  "23621",
  "312221",
  "337211",
  "311411",
  "332212",
  "336212",
  "211112",
  "337125",
  "51211",
  "624229",
  "45322",
  "314120",
  "112310",
  "333292",
  "322221",
  "51913",
  "23835",
  "441221",
  "71391",
  "861102",
  "311920",
  "517000",
  "334517",
  "114111",
  "333511",
  "44411",
  "562910",
  "212291",
  "316990",
  "42385",
  "236117",
  "332420",
  "331491",
  "321211",
  "44112",
  "331492",
  "336214",
  "322212",
  "335911",
  "53119",
  "485991",
  "337121",
  "624210",
  "335220",
  "324122",
  "322130",
  "327910",
  "42393",
  "52591",
  "327331",
  "112111",
  "339992",
  "923",
  "321911",
  "33429",
  "339111",
  "213113",
  "45111",
  "424510",
  "335210",
  "335228",
  "321212",
  "339994",
  "336213",
  "339932",
  "71399",
  "212210",
  "6212",
  "322222",
  "54186",
  "44819",
  "336992",
  "42331",
  "541340",
  "54",
  "311919",
  "335912",
  "511191",
  "322232",
  "445250",
  "321114",
  "532220",
  "339993",
  "112340",
  "56144",
  "336415",
  "339995",
  "325220",
  "22112",
  "42311",
  "492210",
  "327999",
  "4853",
  "517211",
  "322291",
  "71131",
  "325920",
  "481304",
  "559999",
  "42344",
  "311225",
  "311520",
  "541420",
  "332410",
  "394918",
  "334113",
  "532291",
  "22131",
  "326111",
  "571979",
  "44719",
  "333612",
  "42433",
  "42469",
  "512290",
  "152102",
  "483111",
  "44811",
  "315999",
  "311991",
  "315250",
  "42351",
  "075210",
  "446",
  "326130",
  "42321",
  "425",
  "074201",
  "81399",
  "335110",
  "339911",
  "152103",
  "112112",
  "322110",
  "33637",
  "11115",
  "42481",
  "111199",
  "999999",
  "42399",
  "623210",
  "336120",
  "488310",
  "56179",
  "52392",
  "81392",
  "3331",
  "543101",
  "321215",
  "337920",
  "44813",
  "311423",
  "332613",
  "488111",
  "311422",
  "424590",
  "812332",
  "327213",
  "33421",
  "42482",
  "33312",
  "92312",
  "315280",
  "315232",
  "711120",
  "488390",
  "326191",
  "52512",
  "321214",
  "333315",
  "6242",
  "326291",
  "483113",
  "81149",
  "314994",
  "483112",
  "336310",
  "335122",
  "313311",
  "333518",
  "321219",
  "313240",
  "42441",
  "42346",
  "111320",
  "42491",
  "332215",
  "323118",
  "653118",
  "112930",
  "712120",
  "321213",
  "335132",
  "532283",
  "333293",
  "481212",
  "331524",
  "359915",
  "313320",
  "332",
  "315191",
  "333996",
  "174108",
  "32213",
  "336340",
  "92411",
  "311822",
  "42411",
  "45122",
  "54189",
  "212312",
  "111335",
  "311514",
  "327410",
  "311230",
  "322226",
  "152130",
  "71211",
  "333295",
  "322213",
  "332993",
  "611513",
  "425110",
  "332992",
  "3353",
  "353101",
  "509210",
  "311911",
  "333412",
  "621420",
  "313230",
  "315228",
  "23834",
  "738999",
  "49319",
  "81393",
  "323116",
  "322224",
  "32591",
  "44613",
  "322233",
  "42382",
  "487110",
  "927110",
  "333294",
  "315190",
  "312112",
  "81232",
  "62134",
  "42313",
  "333131",
  "333298",
  "339913",
  "525920",
  "325192",
  "62132",
  "111211",
  "32615",
  "525120",
  "551102",
  "315225",
  "323121",
  "331522",
  "6115",
  "171105",
  "339941",
  "315212",
  "42332",
  "315233",
  "42341",
  "23831",
  "315231",
  "32739",
  "722211",
  "327125",
  "6244",
  "335932",
  "335222",
  "311224",
  "175299",
  "211210",
  "333913",
  "315299",
  "152205",
  "44313",
  "322231",
  "53212",
  "325193",
  "335224",
  "313220",
  "221113",
  "522180",
  "325181",
  "81293",
  "23816",
  "335221",
  "339912",
  "561491",
  "238",
  "111110",
  "325131",
  "332997",
  "331312",
  "45439",
  "331319",
  "456199",
  "31134",
  "325212",
  "316110",
  "8121",
  "4411",
  "56152",
  "54141",
  "81291",
  "42391",
  "339942",
  "384104",
  "335910",
  "42386",
  "561431",
  "331315",
  "11212",
  "811112",
  "3334",
  "335212",
  "32551",
  "212230",
  "32552",
  "23833",
  "443130",
  "173101",
  "44221",
  "31212",
  "315192",
  "337212",
  "44521",
  "333516",
  "48832",
  "31321",
  "335929",
  "504908",
  "111411",
  "311313",
  "326140",
  "11114",
  "316211",
  "332214",
  "71119",
  "333210",
  "325992",
  "443",
  "54138",
  "42381",
  "44412",
  "112519",
  "722514",
  "322223",
  "33791",
  "154101",
  "45114",
  "333997",
  "334414",
  "23811",
  "111310",
  "209201",
  "52599",
  "42372",
  "331528",
  "334518",
  "623",
  "42493",
  "316992",
  "111334",
  "176109",
  "729922",
  "532",
  "315239",
  "097101",
  "078102",
  "23814",
  "61162",
  "313111",
  "737311",
  "62131",
  "331419",
  "32622",
  "027301",
  "42371",
  "23829",
  "311330",
  "42373",
  "311312",
  "594515",
  "11299",
  "62191",
  "331313",
  "42451",
  "075205",
  "221114",
  "111219",
  "316999",
  "111422",
  "42394",
  "701101",
  "454312",
  "212325",
  "32731",
  "31213",
  "721120",
  "737101",
  "33711",
  "539901",
  "53223",
  "335211",
  "2361",
  "111150",
  "175106",
  "332112",
  "81231",
  "332213",
  "472402",
  "42442",
  "339943",
  "8111",
  "314912",
  "324199",
  "61142",
  "485",
  "325222",
  "7224",
  "42492",
  "92412",
  "313221",
  "333513",
  "33121",
  "276101",
  "315110",
  "333291",
  "569947",
  "212322",
  "92511",
  "3253",
  "331521",
  "835101",
  "7131",
  "92119",
  "56162",
  "23617",
  "311212",
  "6215",
  "336330",
  "111419",
  "532292",
  "571216",
  "333411",
  "42392",
  "212234",
  "71393",
  "472406",
  "325110",
  "92512",
  "32592",
  "5622",
  "176111",
  "23812",
  "49312",
  "442",
  "599502",
  "315991",
  "174101",
  "315",
  "315223",
  "42472",
  "561",
  "42413",
  "44422",
  "5151",
  "42432",
  "478977",
  "394498",
  "812922",
  "111140",
  "738947",
  "221121",
  "333312",
  "112320",
  "178103",
  "56174",
  "314911",
  "31123",
  "115115",
  "327122",
  "2381",
  "805102",
  "315224",
  "506546",
  "458106",
  "311213",
  "212393",
  "42446",
  "792217",
  "62423",
  "811",
  "336419",
  "738913",
  "738951",
  "731999",
  "61161",
  "737505",
  "23891",
  "311512",
  "33792",
  "336321",
  "112210",
  "42461",
];
